import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

export type PageLayoutMode = 'card-romulus' | 'card' | 'simple';

@Component({
  selector: 'rms-page-layout',
  template: `<ng-content />`,
  host: {
    class: 'rms-page-layout',
  },
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./page-layout.component.scss'],
})
export class PageLayoutComponent {
  @Input() public mode: PageLayoutMode = 'simple';

  @HostBinding('class.rms-page-layout-card')
  public get isCard(): boolean {
    return this.mode === 'card';
  }

  @HostBinding('class.rms-page-layout-simple')
  public get isSimple(): boolean {
    return this.mode === 'simple';
  }

  @HostBinding('class.rms-page-layout-card-romulus')
  public get isRomulusCard(): boolean {
    return this.mode === 'card-romulus';
  }
}
